/* eslint-disable max-len */

import React, { useContext, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useOnClickOutside } from '../../../../../../../CommonMethods/OutsideClick';
import VitalBloodGlouseExport from '../Export';
import FilterObserverBtn from '../Filter';
import { handleSidebarPrvState } from '../../../../../../../redux/systemConfigSlice';
import GlobalContext from '../../../../../../../components/Context/GloablContext';
import { resetDeviceAlertDashboardSearch } from '../../../../../../../redux/deviceAlertDashboardSlice';


const BloodGlouseVitalTopBar = ({
    SearchInput,
    AddButton,
    menuBar,
    handleApplyFilter,
    buttonName,
    ApplyFilter,
    setFilterValues,
    filterValues,
    initialState,
    SearchPlaceholder,
    isColumnSelect,
    setIsColumnSelect,
    exportCols,
    username,
    toAddScreen,
    isExportList,
    isExport,
    setConfirmationState, 
    data, 
    exportVitalDetails, 
    isIdexport, 
    isFilterOrganization,
    vitalTabName,
    isFilterOpen,
    setIsFilterOpen,
    device,
    TotalCount,
    deviceReadingSearch
}) => {

    const [searchParams] = useSearchParams()
    const outSideClick = useRef();
    const dispatch = useDispatch();
    const filtervals = useSelector(state => state.systemConfigData.filterState)
    const [dateError, setdateError] = useState(false)
    useOnClickOutside(outSideClick, () => {
        setIsFilterOpen(false)
    })
    const {isSideBar,setIsAdvancedSearchOpen,setIsSideBar} = useContext(GlobalContext);
    const navigate=useNavigate()


    const handleOpenFilter = () => {
        setdateError(false)
        if (isFilterOrganization) {
            if ((searchParams.get("start_date") !== null || searchParams.get("end_date") !== null) && !isFilterOpen) {
                setFilterValues(filtervals)

            }
            else if (searchParams.get("start_date") === null && searchParams.get("end_date") === null) {
                setFilterValues({
                    "filter_start_date": '',
                    "filter_end_date": '',
                })
            }

        } else {
            if ((searchParams.get("field") !== null || searchParams.get("action") !== null || searchParams.get("start_date") !== null || searchParams.get("end_date") !== null) && !isFilterOpen) {
                setFilterValues(filtervals)
            }
            else if (searchParams.get("field") === null && searchParams.get("user_name") === null && searchParams.get("action") === null && searchParams.get("start_date") === null && searchParams.get("end_date") === null) {
                setFilterValues({
                    "filter_start_date": '',
                    "filter_end_date": '',

                })
            }

        }

        setIsFilterOpen(!isFilterOpen)
    }

    // Function to handle onClick logic
    const handleSearchClick = () => {  
        dispatch(handleSidebarPrvState(isSideBar));
        setIsAdvancedSearchOpen(true);
        setIsSideBar(false);
    };

    const handleNavigation = () => {
        setIsAdvancedSearchOpen(false);
        dispatch(resetDeviceAlertDashboardSearch());
        navigate(`/manage-patients/${location?.pathname?.split('/')?.[2]}`, { 
            state: device === undefined ? 'vital_screen' : 'device_screen' 
        });
    };



    return (
        <div className="mb-[14px]">
            <div className="flex items-center justify-between relative">
                <button onClick={handleNavigation} className='items-center min-w-max flex'>
                    <span>
                        <img loading='lazy' decoding='async' src="/images/back_button_Green.svg" alt="icon" />
                    </span>
                    <span className='text-sm font-normal text-[#008586] ml-3'>{'Go back to View Patient'}</span>
                </button>
                {data?.total_count!==0&&<h1 className="text-xl font-normal text-[#000000] 2xl:self-center 2xl:pt-0 pt-3 self-start min-w-fit ml-1">{device===undefined?'List of Vital Reading History':'List of Device Reading History'}</h1>}
                <div className='flex'>
                    {device!==undefined && 
                        <button id='search-btn' onClick={handleSearchClick} className="xl:ml-2.5 ml-2.5 2xl:mb-0 mb-2.5 border border-[#972E4C] rounded-[15px] px-[13px] py-[12px] min-w-fit">
                            <img loading='lazy' decoding='async' src="/images/search_red.svg" alt="icon" className=''/>
                        </button>
                    }
                    <FilterObserverBtn
                        dateError={dateError}
                        setdateError={setdateError}
                        isFilterOpen={isFilterOpen}
                        setIsFilterOpen={setIsFilterOpen}
                        handleApplyFilter={handleApplyFilter}
                        filterValues={filterValues}
                        setFilterValues={setFilterValues}
                        initialState={initialState}
                        handleOpenFilter={handleOpenFilter} />
                    
                    {data !== undefined && data?.historical_reading?.length > 0 && <div>  <VitalBloodGlouseExport
                        exportVitalDetails={exportVitalDetails}
                        isExportList={isExportList}
                        exportCols={exportCols}
                        setIsFilterOpen={setIsFilterOpen}
                        isColumnSelect={isColumnSelect}
                        setIsColumnSelect={setIsColumnSelect}
                        isIdexport={isIdexport} 
                        username={username}
                        vitalTabName={vitalTabName}     
                        device={device}     
                        TotalCount={TotalCount}           
                    /> </div>}
                </div>
            </div>
        </div>
    );
}

export default BloodGlouseVitalTopBar;
